import React from "react";

import * as S from "./styles";

export const Slide10: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Title>No cometa de Pabllo Vittar</S.Title>
        <S.Text>
          Retomando o eletrobrega em roupagem futurista, a drag queen alça voos
          cada vez mais altos sem esquecer de suas raízes.
        </S.Text>
      </S.Wrapper>
    </S.Container>
  );
};
